import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// ScrollTriggerをGSAPに登録
gsap.registerPlugin(ScrollTrigger);

export function textAnimation01() {
  // textSectionを取得
  const textSections = document.querySelectorAll(".js-text-animation01");

  textSections.forEach((textSection) => {
    // textErement01を取得
    const textErement01 = textSection.querySelector(".js-text-spread");
    // textErement02を取得
    const textErement02 = textSection.querySelectorAll(".js-text-fadeIn");

    // GSAPのタイムラインを作成
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: textSection, // トリガーとなる要素
        start: "top 90%", // アニメーションが開始する位置
        markers: false, // デバッグ用のマーカーを表示（本番環境では削除）
      },
    });

    // textErement01のアニメーション
    tl.fromTo(
      textErement01,
      { scaleX: 0.7, transformOrigin: "left" }, // 初期状態
      {
        scaleX: 1, // 表示時の設定
        duration: 0.4, // アニメーションの持続時間
        ease: "power1.inOut", // イージング効果
      }
    );

    // textErement02のアニメーションを連続して追加
    textErement02.forEach((element, index) => {
      tl.fromTo(
        element,
        { opacity: 0, visibility: "hidden" }, // 初期状態
        {
          opacity: 1, // 表示時の設定
          visibility: "visible",
          duration: 0.4, // アニメーションの持続時間
          ease: "power4.inOut", // イージング効果
          // アニメーションが少しずつ重なるようにするための遅延を追加
          delay: index * 0.2, // 各要素のアニメーションに遅延を追加
        }
      );
    });
  });
}
